import React from 'react'

import { ILocaleContext } from './types'

import { DEFAULT_LOCALE_ID } from './Module'

export const DEFAULT_LOCALE_CONTEXT: ILocaleContext = {
  surveyLocaleID: DEFAULT_LOCALE_ID,
  interfaceLocaleID: DEFAULT_LOCALE_ID
}

export const LocaleContext = React.createContext<ILocaleContext>(DEFAULT_LOCALE_CONTEXT)
export default LocaleContext
